var environments = {
  'development': {
    'apiUrl': 'http://localhost:9292/api/'
  },
  'staging': {
    'apiUrl': 'https://cloud.idonia.com:9000/api/'
  },
  'production': {
    'apiUrl': 'https://demo.idonia.com:9292/api/'
  }
}

var currentEnvironment = process.env.NODE_ENV || 'development'
var config = Object.assign({}, environments[currentEnvironment])

export default config

export function useConfig(config) {
  let c = config || {}
  function get(key) {
    return c[key]
  }

  function set(key, value) {
    c[key] = value
  }
  function setAll(config) {
    c = config
  }
  function getAll() {
    return c
  }
  return {
    get,
    set,
    setAll,
    getAll
  }
}
